import { lazy } from "react";
// project-imports
import Loadable from "components/Loadable";
import { routeConstants } from "services/keyConstants";

const NewProcessValidationYearList = Loadable(
  lazy(() => import("../ProcessValidationYearList"))
);

const MasterValidationPlan = Loadable(
  lazy(() => import("../MasterValidationPlan"))
);

const DocumentDetails = Loadable(lazy(() => import("../DocumentDetails")));
const ValidationProtocolReport = Loadable(
  lazy(() => import("../ValidationProtocolReport"))
);

const PVRoutes = [
  {
    path: routeConstants.PROCESS_VALIDATIONS,
    children: [
      { path: "master-validation-plan", element: <MasterValidationPlan /> },
      // { path: "master-validation-plan-details", element: <MasterValidationPlanById /> },
      // { path: "process-validation-format/:year", element: <ProcessValidationFormat /> },
      // { path: "validation", element: <ValidationList /> },
      {
        path: "validation-protocol-report",
        element: <ValidationProtocolReport />,
      },
      { path: "protocol-detail", element: <DocumentDetails /> },
      // { path: "list/:year", element: <List /> },
      { path: "year-list", element: <NewProcessValidationYearList /> },
    ],
  },
];

export default PVRoutes;
